import React from 'react';
import { useIntl } from 'react-intl';

// Shows the translated error message when the Coaching token could not be obtained.
const CoachingErrorState = ({ messageKey }) => {
  const { messages } = useIntl();

  return (
    <div className="coach-sso-view coach-sso-view--error" role="alert">
      <p className="coach-sso-view__error">{messages[messageKey] || messages['coachSSO_error_generic']}</p>
    </div>
  );
};

export default CoachingErrorState;
